export enum HistoryRuleAction {
  CREATE = 'Create',
  UPDATE = 'Update',
  DELETE = 'Delete'
}
